<tec-tile [id]="OPERATION_TYPE.FINISH"
	[title]="operation.title"
	[formGroup]="group"
	[subtitle]="operation.description"
	[icon]="operation.icon">
	<tec-item
		[title]="'WORKFLOWS.FORM.OPERATIONS.FINISH_RESULT_MESSAGES.TILE_TITLE' | translate"
		[tagImage]="{ icon: 'icon-edit', status: 'default' }"
		[clickeable]="false"
	>
		<tec-list-detail>
			<span>{{ 'WORKFLOWS.FORM.OPERATIONS.FINISH_RESULT_MESSAGES.TILE_SUBTITLE' | translate }}</span>
		</tec-list-detail>
		<tec-link
			[label]="'WORKFLOWS.FORM.OPERATIONS.FINISH_RESULT_MESSAGES.PERSONALIZE' | translate"
			(click)="openResultMessagesModal()"
		></tec-link>
	</tec-item>
	<tec-item
		[title]="'WORKFLOWS.FORM.OPERATIONS.FINISH_SHOW_KO_REASON' | translate"
		[tagImage]="{ icon: 'icon-alert', status: 'default' }"
		[clickeable]="false"
	>
		<tec-list-detail>
			<span>{{ 'WORKFLOWS.FORM.OPERATIONS.FINISH_SHOW_KO_REASON_DESCRIPTION' | translate }}</span>
		</tec-list-detail>
		<tec-switch formControlName="show_ko_reason" size="sm"></tec-switch>
	</tec-item>
	<tec-tile [title]="'WORKFLOWS.FORM.OPERATIONS.FINISH_REDIRECT' | translate"
		[subtitle]="'WORKFLOWS.FORM.OPERATIONS.FINISH_REDIRECT_SUBTITLE' | translate">
		<tec-form-group [label]="'WORKFLOWS.FORM.OPERATIONS.FINISH_OK' | translate"
			[description]="'WORKFLOWS.FORM.OPERATIONS.FINISH_OK_DESCRIPTION' | translate">
			<tec-textarea formControlName="redirect" [placeholder]="'WORKFLOWS.FORM.OPERATIONS.FINISH_OK_PLACEHOLDER' | translate"></tec-textarea>
		</tec-form-group>
		<tec-form-group [label]="'WORKFLOWS.FORM.OPERATIONS.FINISH_KO' | translate"
			[description]="'WORKFLOWS.FORM.OPERATIONS.FINISH_KO_DESCRIPTION' | translate">
			<tec-textarea formControlName="redirect_ko" [placeholder]="'WORKFLOWS.FORM.OPERATIONS.FINISH_KO_PLACEHOLDER' | translate"></tec-textarea>
		</tec-form-group>
		<tec-form-group [label]="'WORKFLOWS.FORM.OPERATIONS.FINISH_CANCELLED' | translate"
			[description]="'WORKFLOWS.FORM.OPERATIONS.FINISH_CANCELLED_DESCRIPTION' | translate">
			<tec-textarea formControlName="redirect_cancelled" [placeholder]="'WORKFLOWS.FORM.OPERATIONS.FINISH_CANCELLED_PLACEHOLDER' | translate"></tec-textarea>
		</tec-form-group>
	</tec-tile>
	<tec-tile [title]="'WORKFLOWS.FORM.OPERATIONS.FINISH_CALLBACK' | translate"
		[subtitle]="'WORKFLOWS.FORM.OPERATIONS.FINISH_CALLBACK_DESCRIPTION' | translate">
		<tec-form-group [label]="'WORKFLOWS.FORM.OPERATIONS.FINISH_CALLBACK_OK' | translate"
			[description]="'WORKFLOWS.FORM.OPERATIONS.FINISH_CALLBACK_OK_DESCRIPTION' | translate">
			<tec-textarea formControlName="callback" [placeholder]="'WORKFLOWS.FORM.OPERATIONS.FINISH_CALLBACK_PLACEHOLDER' | translate"></tec-textarea>
		</tec-form-group>
		<tec-form-group [label]="'WORKFLOWS.FORM.OPERATIONS.FINISH_CALLBACK_KO' | translate"
			[description]="'WORKFLOWS.FORM.OPERATIONS.FINISH_CALLBACK_KO_DESCRIPTION' | translate">
			<tec-textarea formControlName="callback_ko" [placeholder]="'WORKFLOWS.FORM.OPERATIONS.FINISH_CALLBACK_PLACEHOLDER' | translate"></tec-textarea>
		</tec-form-group>
		<tec-form-group [label]="'WORKFLOWS.FORM.OPERATIONS.FINISH_CALLBACK_CANCELLED' | translate"
			[description]="'WORKFLOWS.FORM.OPERATIONS.FINISH_CALLBACK_CANCELLED_DESCRIPTION' | translate">
			<tec-textarea formControlName="callback_cancelled" [placeholder]="'WORKFLOWS.FORM.OPERATIONS.FINISH_CALLBACK_PLACEHOLDER' | translate"></tec-textarea>
		</tec-form-group>
	</tec-tile>
</tec-tile>
